/* eslint-disable class-methods-use-this */
class CookieService {
  public setCookie(cname: string, cvalue: string, exdays: number = 36500): void {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${expirationDate.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  }

  public getCookie(cname: string): string {
    const name = `${cname}=`;
    const cookieArr = document.cookie.split(";");
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cookieArr.length; i++) {
      let c = cookieArr[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  public hasCookie(cname: string): boolean {
    return Boolean(this.getCookie(cname));
  }
}

export default CookieService;
